import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import IssueAttachment from './components/IssueAttachment';
import TransitionList from './components/TransitionList';

class IssueAttachmentsList extends PureComponent {

  render() {
    const { attachments } = this.props;

    if (!attachments || !attachments.length) {
      return null;
    }

    return (
      <div className="IssueAttachmentsList">
        <TransitionList className="IssueAttachmentsList" exitTimeout={480}>
          {
            attachments.map((attachment) => {
              return (
                <IssueAttachment key={attachment.fileId || attachment.id || attachment.clientId}
                  attachment={attachment}
                  container={this}
                  attachmentComponent={this.props.attachmentComponent}
                />
              );
            })
          }
        </TransitionList>
      </div>
    );
  }
}

IssueAttachmentsList.displayName = 'IssueAttachmentsList';
IssueAttachmentsList.attachmentComponents = { ...IssueAttachment.attachmentComponents };

IssueAttachmentsList.propTypes = {
  attachments: PropTypes.array.isRequired,
  attachmentComponent: PropTypes.string,
};

export default IssueAttachmentsList;
